export default "__VITE_ASSET__HD3bnrqU__"